package team.platforma.dictionary_data.network

import kotlinx.serialization.Serializable

@Serializable
data class Config(
    val ai_account_type: String,
    val use_proxy: Boolean
)